// Antd
import { DatePicker, DatePickerProps } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

// Constant
import { DATE_FORMAT_INDONESIA } from 'constant/date.constant'

const FormDatePicker = (props: DatePickerProps) => {
  // Hook
  const { t } = useTranslation()

  return (
    <>
      <DatePicker
        {...props}
        style={{
          width: props?.style?.width ? props?.style?.width : '100%',
        }}
        className={`custom-input common ${props?.className}`}
        format={props?.format || DATE_FORMAT_INDONESIA}
        placeholder={t(props?.placeholder || '')}
        inputReadOnly
      />
    </>
  )
}

export { FormDatePicker }
